import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";

/* eslint-disable no-irregular-whitespace */
import { Alert, Button, ButtonToolbar } from "@icg360/ui-toolkit";
import { func } from "prop-types";
import React, { Component } from "react";
import { APP_IDS } from "../../constants";
import { pacDataPropTypes } from "../../shared/propTypes";
var AGENT_PORTAL = APP_IDS.AGENT_PORTAL;
var styles = {
  label: {
    fontWeight: "normal",
    margin: "0"
  },
  input: {
    marginRight: "6px"
  },
  toolbar: {
    marginTop: "10px"
  }
};

var OverrideRateValidationBlocker = /*#__PURE__*/function (_Component) {
  _inheritsLoose(OverrideRateValidationBlocker, _Component);

  function OverrideRateValidationBlocker() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = OverrideRateValidationBlocker.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        backToEditFormView = _this$props.backToEditFormView,
        _this$props$pacData = _this$props.pacData,
        applicationId = _this$props$pacData.applicationId,
        policyActionId = _this$props$pacData.policyActionId;
    var isChangeEffectiveDateForm = policyActionId === "changeeffectivedate";
    var canOverride = !isChangeEffectiveDateForm && applicationId !== AGENT_PORTAL;
    return /*#__PURE__*/React.createElement(Alert, {
      bsStyle: canOverride ? "warning" : "danger"
    }, /*#__PURE__*/React.createElement("h4", null, "Blocked by Rate Validation Failure"), /*#__PURE__*/React.createElement("p", null, "Your proposed changes were blocked because the rate validation failed.", " ", applicationId === AGENT_PORTAL ? "You must contact Policy Services for assistance processing the proposed changes." : isChangeEffectiveDateForm ? /*#__PURE__*/React.createElement("span", null, "You\xA0must\xA0refer this to\xA0the Product\xA0Implementation\xA0Team\xA0by", " ", /*#__PURE__*/React.createElement("a", {
      href: "https://icg360.atlassian.net/servicedesk/customer/portal/35/group/81/create/302"
    }, "opening a Rate Validation Error Ticket"), " ", "for\xA0assistance\xA0processing\xA0the\xA0proposed\xA0changes.") : /*#__PURE__*/React.createElement("span", null, "You\xA0must\xA0receive approval from the\xA0Product\xA0Implementation\xA0Team\xA0by", " ", /*#__PURE__*/React.createElement("a", {
      href: "https://icg360.atlassian.net/servicedesk/customer/portal/35/group/81/create/302"
    }, "opening a Rate Validation Error Ticket"), " ", "before\xA0overriding\xA0the\xA0rate\xA0validation\xA0block.")), /*#__PURE__*/React.createElement(ButtonToolbar, {
      style: styles.toolbar
    }, canOverride && /*#__PURE__*/React.createElement(Button, {
      type: "submit"
    }, "Override Rate Validation Block"), /*#__PURE__*/React.createElement(Button, {
      bsStyle: canOverride ? "link" : "default",
      onClick: backToEditFormView
    }, "Back to Form")));
  };

  return OverrideRateValidationBlocker;
}(Component);

OverrideRateValidationBlocker.propTypes = {
  pacData: pacDataPropTypes.isRequired,
  backToEditFormView: func.isRequired
};
export { OverrideRateValidationBlocker as default };